import { Navigate } from 'react-router-dom';
import { useIsActiveSubscription } from '../hooks/use-is-active-subscription';
import { useIsFirmRole } from '../hooks/use-is-firm-role';
import PageContainer from '../components/page-container/PageContainer';
import PageTitle from '../components/PageTitle';
import NewWorkpaperForm from '../features/new-workpaper/NewWorkpaperForm';

function NewWorkpaperPage(): JSX.Element {
    const activeSubscription = useIsActiveSubscription();
    const { isExternalUser } = useIsFirmRole();

    if (!activeSubscription || isExternalUser) {
        return <Navigate to=".." />;
    }

    return (
        <PageContainer>
            <div className="pb-4">
                <div className="pb-4 border-b">
                    <PageTitle title="New Workpaper" />
                </div>
                <div className="mx-auto w-full max-w-[80%] mt-8">
                    <NewWorkpaperForm />
                </div>
            </div>
        </PageContainer>
    );
}
export default NewWorkpaperPage;
